import React, { useEffect, useState } from 'react';
import { Modal } from 'react-native';
import { setStatusBarStyle } from 'expo-status-bar';

export interface FenetrePleinEcranProps {
  onFermer: () => void;
  children: React.ReactNode;
}

/**
 * Fenêtre plein écran ouverte par-dessus le panneau de détail, pour la préparation, la relecture et
 * l'étape qui les précède (retour de test sur iPhone, 03/10/2026 : posés DANS le panneau, ces écrans
 * laissaient voir la page d'en dessous derrière l'heure).
 *
 * Icônes de la barre d'état claires tant qu'elle est ouverte, style normal à la fermeture. Le style
 * est posé AU PREMIER RENDU, avant que la fenêtre native ne s'ouvre : Android le recopie dans la
 * fenêtre de la modale à son ouverture seulement (ReactModalHostView.updateSystemAppearance). Sur
 * iOS, `UIViewControllerBasedStatusBarAppearance` vaut false : le style d'application s'applique.
 *
 * Android : `statusBarTranslucent` et `navigationBarTranslucent` font passer la fenêtre sous les deux
 * barres système ; les écrans réservent eux-mêmes leurs marges (CadrePleinEcran).
 */
export function FenetrePleinEcran({ onFermer, children }: FenetrePleinEcranProps) {
  useState(() => setStatusBarStyle('light'));
  useEffect(() => () => setStatusBarStyle('auto'), []);
  return (
    <Modal visible transparent animationType="fade" statusBarTranslucent navigationBarTranslucent onRequestClose={onFermer}>
      {children}
    </Modal>
  );
}
